module.exports = __webpack_public_path__ + "img/cart.73a7d85f.svg";